export default {
  namespaced: true,
  state: {
    totalUnreadMsg: 0, // 未读消息总数
    clearKey: 0, // 清除未读触发的key
    mediaMatch: {
      1: {
        name: '腾讯微视',
        className: 'logo-ws',
      }, // 腾讯微视
      2: {
        name: '全民K歌',
        className: 'logo-kg',
      }, // 全民K歌
      3: {
        name: '企鹅号',
        className: 'logo-om',
      }, // 企鹅号
      4: {
        name: 'QQ',
        className: 'logo-qq',
      }, // QQ
      9: {
        name: '腾讯视频',
        className: 'logo-txvideo',
      }, // 腾讯视频
      15: {
        name: WEB_NAME,
        className: 'logo-eshop',
      }, // 电商中台
    },
  },
  mutations: {
    updateTotalUnreadMsg(state, data) {
      state.totalUnreadMsg = data;
    },
    // 更新数据触发header中的消息盒子更新列表
    updateClearKey(state, data) {
      state.clearKey = data;
    },
  },
};
